import complianceImg from "../../../../static/images/banners/compliance-bg.png";

export const ComplianceBanner = () => {
  return (
    <div
      className="bg-[#0046AD] rounded-[0.688rem] min-h-[12rem] relative bg-no-repeat bg-contain bg-right w-full px-[3.375rem] py-[2.063rem] flex gap-x-[2.875rem] items-center"
      style={{ backgroundImage: `url('${complianceImg}')` }}
    >
      <div className="">
        <svg
          width="26"
          height="25"
          viewBox="0 0 26 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 5H18.9151C18.679 3.60197 17.9554 2.33275 16.8726 1.41747C15.7898 0.502181 14.4178 0 13 0C11.5822 0 10.2102 0.502181 9.12739 1.41747C8.04459 2.33275 7.32097 3.60197 7.0849 5H2C1.46975 5.0006 0.961398 5.21151 0.586456 5.58645C0.211515 5.9614 0.000606423 6.46975 0 7V23C0.000606423 23.5302 0.211515 24.0386 0.586456 24.4135C0.961398 24.7885 1.46975 24.9994 2 25H24C24.5302 24.9994 25.0386 24.7885 25.4135 24.4135C25.7885 24.0386 25.9994 23.5302 26 23V7C25.9994 6.46975 25.7885 5.9614 25.4135 5.58645C25.0386 5.21151 24.5302 5.0006 24 5ZM8.99902 10C8.99902 10.2652 8.89367 10.5196 8.70613 10.7071C8.51859 10.8946 8.26424 11 7.99902 11C7.73381 11 7.47945 10.8946 7.29192 10.7071C7.10438 10.5196 6.99902 10.2652 6.99902 10V8C6.99902 7.73478 7.10438 7.48043 7.29192 7.29289C7.47945 7.10536 7.73381 7 7.99902 7C8.26424 7 8.51859 7.10536 8.70613 7.29289C8.89367 7.48043 8.99902 7.73478 8.99902 8V10ZM9.12659 5C9.34839 4.14135 9.84921 3.38074 10.5503 2.8377C11.2515 2.29467 12.1132 2 13 2C13.8868 2 14.7485 2.29467 15.4497 2.8377C16.1508 3.38074 16.6516 4.14135 16.8734 5H9.12659ZM18.999 10C18.999 10.2652 18.8937 10.5196 18.7061 10.7071C18.5186 10.8946 18.2642 11 17.999 11C17.7338 11 17.4795 10.8946 17.2919 10.7071C17.1044 10.5196 16.999 10.2652 16.999 10V8C16.999 7.73478 17.1044 7.48043 17.2919 7.29289C17.4795 7.10536 17.7338 7 17.999 7C18.2642 7 18.5186 7.10536 18.7061 7.29289C18.8937 7.48043 18.999 7.73478 18.999 8V10Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="text-white font-grotesque max-w-xl">
        <h2 className="text-2xl mb-2 font-extrabold">
          Compliance is Required!
        </h2>
        <p className="text-[#A2ACD5] font-bold mb-2">
          Sign an MSA, submit company document to get started.
        </p>
        <p className="font-medium mb-4">
          If you're experiencing any technical issues while trying to submit
          compliance documents, contact our live chat now.
        </p>
        <button className="bg-[#FFFFFF] rounded-full font-bold text-[#0046AD] text-sm px-10 py-2">
          Live Chat
        </button>
      </div>
    </div>
  );
};
